import axios from "axios";

const BASE_API_URL = "/api/v1";

async function getLanguageLevels() {
  try {
    const response = await axios.get(`${BASE_API_URL}/languageLevel/`, {
      withCredentials: true,
    });
    console.log("рівні", response.data);

    return response.data;
  } catch (error) {
    console.error("Error fetching language levels:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch language levels."
    );
  }
}

async function getLanguageLevelById(id) {
  try {
    const response = await axios.get(`${BASE_API_URL}/languageLevel/${id}/`, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching language level with id ${id}:`, error);
    throw new Error(
      error.response?.data?.message ||
        `Failed to fetch language level with id ${id}.`
    );
  }
}

export { getLanguageLevels, getLanguageLevelById };
